import { Outlet } from 'react-router-dom'
import { useAuth } from '../providers/AuthProvider'

export function PublicOnlyRoute() {
  const { isReady } = useAuth()

  if (!isReady) {
    return (
      <section className="page-section">
        <div className="page-card">Authentifizierung wird geladen...</div>
      </section>
    )
  }

  return <Outlet />
}